import { render } from "./App.vue?vue&type=template&id=5862076e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5862076e&lang=css"
script.render = render

export default script